<template>
  <ChatIA />
</template>

<script>
import ChatIA from "@/components/ri3/ia/ChatIA.vue"

export default {
  name: "IAChat",
  components: {
    ChatIA
  },
  computed: {
    company() {
      return this.$store.state.app.company
    }
  },
  data() {
    return {
      members: []
    }
  }
}
</script>
